import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import PromotionsTabs from "../components/promotions/PromotionsTabs";

export default function PromotionsPage() {
    return (
        <>
            <PageMeta
                title="Promotions | Shoplattice Admin Dashboard"
                description="Manage Coupon Codes and Offers"
            />
            <PageBreadcrumb pageTitle="Promotions" />
            <div className="space-y-6">
                <PromotionsTabs />
            </div>
        </>
    );
}
